/**
 *
 * @module geoLocation
 *
 */

import Check from 'check-types';
import Exception from './../services/exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    number
} = Check.assert;

/**
 *
 * @class GeoLocation
 * @desc Represents a geographic location.
 *
 */
export default class GeoLocation {

    /**
     *
     * @param {Number} longitude
     * @param {Number} latitude
     *
     */
    constructor(longitude, latitude) {

        const errorMessage = {
            ctor: 'GeoLocation(longitude, latitude)',
            get longitude() {
                return `${this.ctor} longitude should be a Number`;
            },
            get latitude() {
                return `${this.ctor}latitude should be a Number`;
            }
        };

        number(latitude, errorMessage.latitude, InvalidArgumentException);
        number(longitude, errorMessage.longitude, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Number}
         * @desc The longitude of the location.
         *
         */
        this.longitude = longitude;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The latitude of the location.
         *
         */
        this.latitude = latitude;

    }

}



// WEBPACK FOOTER //
// ./src/token/geoLocation.js